import React from "react";
import { Button, Carousel, Col, Row } from "antd";

import "./Scroll.css";
import importExport from "../../Images/Dashboard2.png";
import image2 from "../../Images/DashboardImage12.png";
import image3 from "./homeImage/bghome.png";
import image4 from "./homeImage/Rubberblanket.jpg";
import image5 from "./homeImage/c1.webp";
import image6 from "./homeImage/c1.webp";
import image7 from "./homeImage/c2.webp";
import image8 from "./homeImage/c3.webp";
import image9 from "./homeImage/image1.webp";
import image10 from "./homeImage/image2.webp";
import image11 from "./homeImage/image3.jpg";
import image12 from "./homeImage/image4.webp";
import bannerImage from "./homeImage/tandaBANNER34.png";
import bannerImage2 from "../../Images/RUBBERSHEET55.png";
// import a3 from "./homeImage/a3.jpeg"
import a5 from "./homeImage/a5.jpeg";
import a6 from "./homeImage/a6.jpeg";
// import a7 from "./homeImage/a7.jpeg"

import a1 from "./homeImage/i1.jpeg";
import a2 from "./homeImage/i2.jpeg";
import a3 from "./homeImage/i3.jpeg";
import a7 from "./homeImage/i4.jpeg";

import { useNavigate } from "react-router-dom";
import HeroBanner from "./HeroBanner";
import underConstruction from "../../assets/underConstruction.png";

const Home = () => {
  let navigate = useNavigate();
  const BannerImg = [
    { id: 4, title: "title1", image: a1 },
    { id: 5, title: "title1", image: a2 },
    { id: 6, title: "title1", image: a3 },
    { id: 8, title: "title1", image: a5 },
    { id: 9, title: "title1", image: a6 },
    { id: 11, title: "title1", image: a7 },
  ];

  return (
    <div>
      <Row>
        <HeroBanner />
      </Row>

      <Row>
        <Col
          xl={{ span: 12 }}
          lg={{ span: 12 }}
          md={{ span: 24 }}
          sm={{ span: 24 }}
          xs={{ span: 24 }}
          className="flex items-center justify-center mt-8 md:px-1 px-9"
        >
          <img
            src={image2}
            className="w-full h-auto max-h-[42vh] md:max-h-[48vh] object-contain md:ml-8"
          />
        </Col>

        <Col
          xl={{ span: 12 }}
          lg={{ span: 12 }}
          md={{ span: 24 }}
          sm={{ span: 24 }}
          xs={{ span: 24 }}
          className="md:p-16 p-6 flex flex-col justify-center"
        >
          <p className="lg:text-5xl md:text-4xl text-3xl text-gray-800 font-extrabold md:ml-10 text-center">
            Understand Customer Better than anyone{" "}
          </p>
          <p className="animate-bounce lg:text-5xl md:text-4xl text-3xl bg-gradient-to-r from-cyan-400 via-teal-800 to-stone-700 text-transparent bg-clip-text font-extrabold md:ml-10 text-center md:mt-6 mt-10">
            TANDA RUBBER WORKS{" "}
          </p>
          <p className="lg:text-xl md:text-lg text-base text-center text-gray-800 font-bold md:ml-10 md:mt-8">
            Get the best Product with High Quality
          </p>
        </Col>
      </Row>
      <Row>
        <Col
          xl={{ span: 12 }}
          lg={{ span: 12 }}
          md={{ span: 24 }}
          sm={{ span: 24 }}
          xs={{ span: 24 }}
          className="flex items-center justify-center mt-8 md:px-1 px-9"
        >
          <img
            src={importExport}
            className="w-full h-auto max-h-[42vh] md:max-h-[48vh] object-contain md:ml-8"
          />
        </Col>
        <Col
          xl={{ span: 12 }}
          lg={{ span: 12 }}
          md={{ span: 24}}
          sm={{ span: 24 }}
          xs={{ span: 24 }}
          className="md:p-16 p-6 flex flex-col justify-center"
        >
          <p className="lg:text-5xl md:text-4xl text-3xl text-gray-800 font-extrabold md:ml-10 text-center">
            Global Trade Simplified
          </p>
          <p  className="animate-bounce lg:text-5xl md:text-4xl text-3xl bg-gradient-to-r from-cyan-400 via-teal-800 to-stone-700 text-transparent bg-clip-text font-extrabold md:ml-10 text-center md:mt-6 mt-10">
            Importing Quality, Exporting Trust.
          </p>
          <p className="lg:text-xl md:text-lg text-base text-center text-gray-800 font-bold md:ml-10 md:mt-8">
            Connecting global markets with seamless import-export solutions.​
          </p>
        </Col>
      </Row>

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          background: "#f5f5f5",
          marginTop: "10px",
        }}
      >
        <img
          src={bannerImage}
          alt="Tanda Export Banner"
          style={{
            width: "100%",
            height: "auto",
            objectFit: "cover",
            display: "block",
          }}
        />
      </div>
      <section className="overflow-hidden text-neutral-700 my-4  bg-black/60">
        <h1 className="text-sm sm:text-3xl text-white font-serif font-bold ml-3 mt-3 mb: md:-mb-2 text-center">
          Our Product
        </h1>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            background: "#f5f5f5",
            marginTop: "15px",
          }}
        >
          <img
            src={bannerImage2}
            alt="Tanda Export Banner"
            style={{
              width: "100%",
              height: "auto",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
        {/* <div className="px-4 bg-slate-400 bg-opacity-25 mt-2">
          <div className="flex overflow-x-scroll scrollbar-none mt-4">
            <div className="slider">
              <div className="slide-track ">
                {BannerImg?.map((item) => (
                  <div className="slide ">
                    <div
                    // onClick={() => navigate("/cleaning-pest-control-equipmet")}
                    >
                      <img className="img__img" src={item?.image} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div> */}
      </section>
    </div>
  );
};

export default Home;
